window["engagement-finder"] =  window['engagement-finder']  ||  {}
export default {
  name: "RelanceConfigurationPage",
  components: {
    ...window["engagement-finder"].default
  },
  data: () => ({
    language: "fr"
  })
}